import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { visibleAdminTabs } from './adminTabs';

function AdminLayout() {
  const { can } = useAuth();
  const tabs = visibleAdminTabs(can);

  return (
    <div>
      <div className="page-header">
        <h2>⚙️ Admin</h2>
      </div>

      {tabs.length > 0 && (
        <div className="admin-tabs">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) => `admin-tab ${isActive ? 'active' : ''}`}
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      )}

      <Outlet />
    </div>
  );
}

export default AdminLayout;
